export default function Footer() {
    
    return (
        <footer className="flex items-center justify-between flex-shrink-0 p-4 max-h-14 bg-[#f5f8fa] dark:bg-[#333333]">
            <div className="flex gap-1 text-xs">
                <span>
                    {new Date().getFullYear()} &copy;
                </span>
                <span>نسخه داشبورد: 0.0.1</span>
            </div>
            <div>
                <span className="text-xs">
                    All rights reserved
                </span>
            </div>
        </footer>
    )
}